export default {
      id: "common__chevron_right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__chevron_right",
      toString: function () {
        return this.url;
      }
    }